/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_OpenInputs */



/**
* | output |
* | --- |
* | "Chat with Wundo" |
*
* @param {Chat_OpenInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_open = /** @type {((inputs?: Chat_OpenInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_OpenInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Chat met Wundo")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Discuter avec Wundo")
	return /** @type {LocalizedString} */ ("Chat with Wundo")
});